import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router";

import { routeCodes } from "../../config/routes";
import { gtmJoinClick } from "../../utilities/gtm";
import { getString } from "../../utilities";
import { language, userRoles } from "../../config/constants";
import FlareShimmer from "../global/FlareShimmer";
import Shimmer from "../../../assets/img/shimmer.png";
import { isLoggedInSelector, modalToggle, roleSelector } from "../../redux/slices/loginSlice";
import { mpSubCTASelect } from "../../utilities/mixpanel";
import { getLangCode } from "../../config";
import LocaleLink from "./LocaleLink";
import SubMenuDropDown from "./SubMenuDropDown";

export default function Nav() {
  const location = useLocation();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const role = useSelector(roleSelector);
  const dispatch = useDispatch();
  const isStudent = isLoggedIn && role === userRoles.student;
  const langCode = getLangCode();

  const renderJoin = (classNames, { doesShimmer } = { doesShimmer: false }) => {
    if (!isLoggedIn) {
      return (
        <Link
          to={routeCodes.SUBSCRIBE}
          className={classNames.join(" ")}
          onClick={() => {
            gtmJoinClick(location.pathname, "header-link");
            mpSubCTASelect("general", "header", getString("join.1", { html: true }), location.pathname);
          }}
        >
          {doesShimmer && <FlareShimmer filePath={Shimmer} />}
          {getString("join.1", { html: true })}
        </Link>
      );
    }
    if (role === userRoles.free) {
      return (
        <Link
          to={routeCodes.MANAGE}
          className={classNames.join(" ")}
          onClick={() => mpSubCTASelect("general", "header", getString("upgrade.title.1"), location.pathname)}
        >
          {doesShimmer && <FlareShimmer filePath={Shimmer} />}
          {getString("upgrade.title.1")}
        </Link>
      );
    }
  };

  let loginPath = "navigation.login.2";
  let logoutPath = "navigation.logout.3";
  let parteaPath = "parentsTeachers.title.2";
  if (langCode !== language.default) {
    loginPath = "navigation.login.0";
    logoutPath = "navigation.logout.0";
    parteaPath = "parentsTeachers.title.1";
  }

  return (
    <>
      <div data-testid="header-mobile-nav" className="header-nav-full mobile-nav">
        {renderJoin(["hnf-premium", "premium-join"], { doesShimmer: true })}
        {!isLoggedIn && (
          <a
            onClick={() => dispatch(modalToggle())}
            className={`loginOut ${langCode === language.la ? "header-login" : ""}`}
          >
            {getString(loginPath, { html: true })}
          </a>
        )}
        <SubMenuDropDown title={getString("navigation.menu")} dropStyles={["right-justified"]} isBurger>
          {renderJoin(["mobile-join"])}
          {!isLoggedIn && langCode === language.la && (
            <a
              onClick={() => dispatch(modalToggle())}
              className={`loginOut ${langCode === language.la ? "hamburger-login" : ""}`}
            >
              {getString(loginPath, { html: true })}
            </a>
          )}
          <Link to={routeCodes.PARTEA}>{getString(parteaPath, { html: true })}</Link>
          {isStudent && <Link to={routeCodes.TOOLS}>{getString("tools.title.1")}</Link>}
          <LocaleLink isCta />
          {isLoggedIn && !isStudent && <Link to={routeCodes.MANAGE}>{getString("manage.title.1")}</Link>}
          {isLoggedIn && (
            <a onClick={() => dispatch(modalToggle())} className="loginOut">
              {getString(logoutPath, { html: true })}
            </a>
          )}
        </SubMenuDropDown>
      </div>
      <div data-testid="header-desktop-nav" className="header-nav-full desktop-nav">
        {renderJoin(["hnf-premium", "premium-join"], { doesShimmer: true })}
        <Link to={routeCodes.PARTEA}>{getString(parteaPath, { html: true })}</Link>
        {isStudent && <Link to={routeCodes.TOOLS}>{getString("tools.title.1")}</Link>}
        {!isLoggedIn && (
          <a onClick={() => dispatch(modalToggle())} className="loginOut">
            {getString(loginPath, { html: true })}
          </a>
        )}
        {isLoggedIn && !isStudent && (
          <SubMenuDropDown title={getString("myAccount")} dropStyles={["centered"]}>
            <Link to={routeCodes.MANAGE}>{getString("manage.title.1")}</Link>
            <a onClick={() => dispatch(modalToggle())} className="loginOut">
              {getString(logoutPath, { html: true })}
            </a>
          </SubMenuDropDown>
        )}
        {isLoggedIn && isStudent && (
          <a onClick={() => dispatch(modalToggle())} className="loginOut">
            {getString(logoutPath, { html: true })}
          </a>
        )}
        <SubMenuDropDown title={getString(`locale.${getLangCode()}`)} dropStyles={["right-justified"]}>
          <LocaleLink />
        </SubMenuDropDown>
      </div>
    </>
  );
}
